module.exports = __webpack_public_path__ + "./images/f6e33b8ab49cc42d41a1ecb8049aaa4a.webp";